export const isInvalidAmount = ({ amount, formattedAmount }) => {
  return isNaN((amount || formattedAmount) as any)
}

export const getRate = ({ uuid, currency }) => {
  // HACK: this is a hack to add increased APU for one user
  const USERS_ID_WITH_INCREASED_APY = ['7a5b9e16-a071-46bd-8899-ce3a7b33f0e8', '0363fefd-7a1c-4032-9dd6-94239e730673']

  if (USERS_ID_WITH_INCREASED_APY.includes(uuid) || currency === 'BJF') {
    return 0.3
  }

  return 0.15
}

export const getAPY = ({ amount, formattedAmount, me, rate }) => {
  const isInvalid = isInvalidAmount({ amount, formattedAmount })

  if (isInvalid) {
    return 0
  }
  const total = Number(amount) || formattedAmount

  return Math.abs(total * rate)
}
